import CONSTANTS from "../../assets/js/Constants"

const lopXe = { 
	tirePhuongtien: [],
	tirePhutung: [],
	tireDanhsach: [],
	detailPhuongtien: {},
	reportByVehicle:[],
	reportByTire:[]
}

export default function (state = lopXe, { type, payload }) {
	switch (type) {
		case CONSTANTS.ACTION.TIRE.SET_LIST_PHUONGTIEN:
			return { ...state, tirePhuongtien: payload}
		
		case CONSTANTS.ACTION.TIRE.SET_LIST_PHUTUNG:
			return { ...state, tirePhutung: payload}
		
		case CONSTANTS.ACTION.TIRE.SET_LIST_BYTIME:
			return { ...state, tireDanhsach: payload}
		
		case CONSTANTS.ACTION.TIRE.SET_DETAIL_PHUONGTIEN:
			// console.log('loxXe pre_data ',state)
			return { ...state, detailPhuongtien: payload}
			//return { ...state, state.detailPhuongtien: payload}	// ERR

		case CONSTANTS.ACTION.TIRE.SET_LIST_BYTIME_BYVEHICLE:
			return { ...state, reportByVehicle: payload}	
		
		case CONSTANTS.ACTION.TIRE.SET_LIST_BYTIME_BYTIRE:
			return { ...state, reportByTire: payload}
		
		default:
			return { ...state }
	}
}


/*
tirePhuongtien = [
	{
	}
]       

tirePhutung = [
	{
	}
]

*/
        
